// src/components/Footer.jsx
import React from "react";
import logo from "../assets/LV.png"; // Cambia la ruta si es necesario
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa"; // Importa los iconos necesarios

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white">
      {/* Sección blanca superior del Footer */}
      <div className="container mx-auto px-6 lg:px-20 py-5 flex flex-col sm:flex-row items-center sm:justify-between">
        {/* Logo */}
        <div className="mb-4 sm:mb-0">
          <img src={logo} alt="Living Soils Logo" className="w-24 h-auto" />
        </div>

        {/* Redes sociales */}
        <div className="flex text-center mx-auto space-x-2 mb-14 sm:mb-0">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-gray-700"
          >
            <FaFacebookF className="w-6 h-6" />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-gray-700"
          >
            <FaTwitter className="w-6 h-6" />
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-gray-700"
          >
            <FaInstagram className="w-6 h-6" />
          </a>
          <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-gray-700"
          >
            <FaYoutube className="w-6 h-6" />
          </a>
        </div>

        {/* Información de contacto */}
        <div>
          <p className="text-black text-sm">
            Contacta'ns:{" "}
            <a
              href="mailto:info@living-soils.eu"
              className="underline hover:text-gray-700"
            >
              info@living-soils.eu
            </a>
          </p>
        </div>
      </div>

      {/* Sección negra inferior del Footer */}
      <div className="bg-black py-4">
        <div className="container mx-auto px-6 lg:px-20 text-right">
          {/* Línea separadora */}
          <div className="w-full border-t border-white mb-2"></div>
          <p className="text-white text-xs">
            © {currentYear} <span className="font-bold"> Living Soils </span> | Version 3.0 |
Powered by{" "}
            <a
              href="https://quantalabs.com"
              className="underline text-white"
            >
              QuantaLabs
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;